import { Trans, useLingui } from '@lingui/react/macro'
import { Box } from 'designSystem/components/Box'
import { Button } from 'designSystem/components/Button'
import { Field, FieldError, FieldLabel } from 'designSystem/components/Field'
import { Input } from 'designSystem/components/Input'
import {
  type ChangeEvent,
  type FormEvent,
  type ReactElement,
  useId,
  useState,
} from 'react'

type LotoNewDraftFormProps = {
  disabled: boolean
  creating: boolean
  failedName: string | undefined
  onCreate: (name: string) => Promise<boolean>
}

export function LotoNewDraftForm({
  disabled,
  creating,
  failedName,
  onCreate,
}: LotoNewDraftFormProps): ReactElement {
  const { t } = useLingui()
  const nameId = useId()
  const [name, setName] = useState(failedName ?? '')
  const changeName = (event: ChangeEvent<HTMLInputElement>): void =>
    setName(event.target.value)
  const submit = async (event: FormEvent<HTMLFormElement>): Promise<void> => {
    event.preventDefault()
    if (await onCreate(name)) setName('')
  }
  return (
    <form onSubmit={submit}>
      <Field>
        <FieldLabel htmlFor={nameId}>
          <Trans>Report name</Trans>
        </FieldLabel>
        <Box display='flex' gap='sm'>
          <Input
            id={nameId}
            value={name}
            maxLength={500}
            placeholder={t`e.g. Pump B isolation`}
            disabled={disabled}
            onChange={changeName}
          />
          <Button type='submit' disabled={disabled || !name.trim()}>
            {creating ? <Trans>Creating…</Trans> : <Trans>Create</Trans>}
          </Button>
        </Box>
        {failedName !== undefined && failedName === name.trim() && (
          <FieldError>
            <Trans>Could not create the LOTO report. Try again.</Trans>
          </FieldError>
        )}
      </Field>
    </form>
  )
}
